import { Head, useForm, Link } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"
import { MemberLayout } from "../components/MemberLayout"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { CrucialConversationForm } from "./CrucialConversationForm"

export default function CrucialConversationNew({ currentUser, userGroupRole, groupMembers = [] }) {
  const isCoach = userGroupRole === "coach"
  const form = useForm({
    topic_issue: "",
    why_crucial: "",
    describe_biz: "",
    how_know: "",
    options: "",
    specific_questions: "",
    relevant_verses: "",
    category: "professional",
    urgency: 5,
    account_id: "",
    pdf_file: null,
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    form.post("/app/member/crucial_conversations", {
      forceFormData: true,
    })
  }

  return (
    <MemberLayout currentUser={currentUser}>
      <Head title="New Crucial Conversation - Kingdom Factor" />

      <div className="max-w-2xl mx-auto space-y-6">
        {/* Back link */}
        <Link
          href="/app/member/crucial_conversations"
          className="inline-flex items-center gap-1.5 text-sm text-zinc-600 hover:text-zinc-900 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Crucial Conversations
        </Link>

        {/* Header */}
        <div>
          <h1 className="text-2xl font-bold text-zinc-900">New Crucial Conversation</h1>
          <p className="text-zinc-600 mt-1">
            Bring a significant issue to your group for structured discussion.
          </p>
        </div>

        {/* Form */}
        <Card>
          <CardContent className="p-6">
            <form onSubmit={handleSubmit} className="space-y-6">
              <CrucialConversationForm
                form={form}
                isCoach={isCoach}
                groupMembers={groupMembers}
              />

              <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 pt-2">
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => window.history.back()}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="gradient"
                  disabled={form.processing}
                >
                  {form.processing ? "Creating..." : "Create Conversation"}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </MemberLayout>
  )
}
